<template>
    <div class="main-container">
         <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Breadcrumb alignment -->
        <breadcrumb :list="breadcrumbList" />
         <tl-tabs 
            :tabs="tabs" 
            class="margintop-32" 
            :customclass="true"
            :showcount="true"
            >
         </tl-tabs>
         <div class="searchsort">
            <tl-search @change="filterData"/>
             <div class="sorttext">
            <span>Sort By: </span>
          </div>
          &nbsp; &nbsp; &nbsp;
          <div class="selectdiv">
              <select v-model="sort" class="dropdown">
                  <option selected="selected">Recently Joined</option>
                  <option>Admin</option>
                  <option>IT</option>
              </select>
            </div> 
         </div>
    </div>
</template>

<script>
export default {
  data(){
      return{
        breadcrumbList:[
        {
          name: "New Team",
          url: `/dashboard/${this.$route.params.entity_index}/myteam`
        },
        {
          name: "Approval",
          url: `/dashboard/${this.$route.params.entity_index}/myteam/approval`
        }
      ],
          tabs: [{
          header: "Pending",
          count: 15
        },
        {
          header: "Approved",
          count: 5
        },{
          header: "Rejected",
          count: 3
        },{
          header: "All",
          count: 23
        }],
        sort: 'Recently Joined'
      }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; 
.content{
    margin-left: 20px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
}
.subtitle{
  width: 316px;
  height: 15px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
}
.searchsort{
  display: flex;
  align-items: center;
  width: 100%;
  padding-right: 10px;
  .sorttext{
    text-align: center;
    line-height: 30px;
    color: #726f75;
    padding: 0px 0px 0px 10px;
    margin-left: auto;
   }
}
select .dropdown {
    border-radius: 4px;
    border: 1px solid #dadada;
    padding: 10px;
    transition: ease-in-out, width 0.35s ease-in-out;

    &:focus {
        outline: none;
        border: 2px solid #37c6c0;
    }
}
.selectdiv {
    select {
        border-radius: 4px;
        outline: 0;
        font-size: 14px;
        color: #9f9da2;
        border: 1px solid #dadada;
        padding: 0 10px;
      &.errorr{
        border: 1px solid #e01717;
      }
      &.errorMessage {
        color: #e01717;
      }
    }
}
</style>
